export const goldenCoinConfig = {
  minValue: 10_000,
  profitPercentage: 0.05,
}
